// Feature flag (see docs/FEATURE_FLAGS.md) gating the "Frequência" report
// (attendance ranking and class occupancy) and the teacher's "Minhas turmas"
// card (amsm-backend's
// `hall/feature_flags/migrations/0014_seed_attendance_ranking_flag.py` seeds
// this exact name, off, in every tenant). It's turned on per tenant once its
// teachers take roll call in the app: without roll calls the report has no
// data. The backend re-checks this same flag on both report endpoints, so
// this is a UI convenience, not the only gate. The roll call itself isn't
// gated — it replaces the one that already existed.
//
// Consume with `useFeatureFlag(ATTENDANCE_RANKING_FLAG)`
// (`app/ducks/featureFlags/hooks`).
export const ATTENDANCE_RANKING_FLAG = 'attendance_ranking'
